import { createFileRoute } from "@tanstack/react-router";
import RegionPage from "@/pages/RegionPage";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/region/$region/")({
  head: ({ params }) => routeHead("/region/$region/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <RegionPage />
  );
}
